import { useCallback, useEffect } from 'react';
import useTask from '../../../../modules/tasks/hooks/use-task';
import LibraryEmail from '../../../library-email';

type Props = {
    onComplete?: () => void
}

const Task203: React.FC<Props> = ({ onComplete: completeCallback }) => {

    const onComplete = useCallback(() => {
        if (completeCallback) {
            completeCallback();
        }
    }, [completeCallback]);

    const { task } = useTask('t-203');

    useEffect(() => {
        onComplete();
    }, [onComplete])

    return <div className="task task-203">
        <h2>zadanie 3</h2>
        <h3>{task?.title}</h3>
        <p>
            Ostatnimi czasy coraz większą popularność zdobywają audiobooki czyli nagrane przez lektora lub lektorkę treści książek. Taka osoba musi mieć dobrą dykcję, czyli poprawnie i wyraźnie wymawiać poszczególne wyrazy. Ważna jest również modulacja głosu czyli dostosowywanie wysokości, barwy i siły głosu do czytanej treści.
        </p>
        <p className="instruction">
            <strong>Zadanie:</strong> Znajdźcie w bibliotece książkę “Kuchnia polska”, a następnie spróbujcie swoich sił jako lektorki i lektorzy, czytając jeden wybrany przez Was przepis. Nagrajcie swoje fragmenty w formie audio lub video i prześlijcie je na adres mailowy Waszej biblioteki!
        </p>
        <LibraryEmail />
    </div>
}

export default Task203;
